import React, { FC } from 'react'

import { Stack, useTheme } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import messageSentIcon from '../../assets/icons/messageSent.svg'
import { useAppDispatch } from '../../store/hooks'
import { CustomButton } from '../CustomButton'

import { closeContactUsModal } from './ContactUsModalSlice'

export const Success: FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  const dispatch = useAppDispatch()

  return (
    <Stack
      flexDirection="column"
      spacing={4}
      justifyContent={'center'}
      alignItems={'center'}
      my={2}
    >
      <img src={messageSentIcon} alt="message sent" />
      <Typography variant={'h1'}>{t('contactUs.success.title')}!</Typography>

      <Typography fontSize={'16px'} fontWeight={500} align="center">
        {t('contactUs.success.text')}
      </Typography>

      <CustomButton onClick={() => dispatch(closeContactUsModal())} width={theme.spacing(17)}>
        {t('contactUs.success.action.close')}
      </CustomButton>
    </Stack>
  )
}
